export const localFeatureIds = [
  //
  'export video',
  'ss onboarding',
  'smartlook-canvas',
  'viz-options',
  'ss-spoak-sign',
  'magic-paint',
  'rich-color-filter',
  'autocomplete-brand-import',
  'mobile-viz',
  'fp-add-room',
  'professional-trial-14-days',
  'about-your-palette',
  'popular-products-home',
] as const

export const externalFeatureIds = [
  //
  'smartlook-canvas',
  'ss-spoak-sign',
  'magic-paint',
  'rich-color-filter',
  'autocomplete-brand-import',
  'mobile-viz',
  'professional-trial-14-days',
  'about-your-palette',
  'popular-products-home',
] as const

export type LocalFeatureId = (typeof localFeatureIds)[number]
export type ExternalFeatureId = (typeof externalFeatureIds)[number]
export type FeatureId = LocalFeatureId | ExternalFeatureId

export function isLocalFeature(
  featureId: FeatureId,
): featureId is LocalFeatureId {
  return localFeatureIds.includes(featureId as LocalFeatureId)
}

export function isExternalFeature(
  featureId: FeatureId,
): featureId is ExternalFeatureId {
  return externalFeatureIds.includes(featureId as ExternalFeatureId)
}
